import { render, staticRenderFns } from "./UiAccordion.vue?vue&type=template&id=0d37c2b6&scoped=true"
import script from "./UiAccordion.vue?vue&type=script&lang=js"
export * from "./UiAccordion.vue?vue&type=script&lang=js"
import style0 from "./UiAccordion.vue?vue&type=style&index=0&id=0d37c2b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d37c2b6",
  null
  
)

export default component.exports